module.exports = __webpack_public_path__ + "img/link.d60d6bfa.png";